<template>
  <div class="t-center">
    <img src="../img/empty/空空如也.png" alt="" srcset="" class="img">
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: "empty",
  props: {
    title: {
      type: String,
      default() {
        return '暂无数据';
      },
    },
  },
};
</script>

<style lang="scss" scoped>
    .img{
        width: 40%;
    }
    .title{
        margin-top: 20px;
        color: #666;
    }
</style>